"use client";
import { useEffect } from "react";
import { runCookieConsentConfig } from "@/components/cookieConsent";

export default function CookieConsentClient({ lang }) {
  useEffect(() => {
    console.log("[CookieConsentClient] useEffect ejecutado", lang);
    if (window._ccRun) return;
    // Cargar el script UMD dinámicamente
    const script = document.createElement('script');
    script.src = '/vendor/cookieconsent.umd.js';
    script.async = true;
    script.onload = () => {
      if (window.CookieConsent) {
        runCookieConsentConfig(lang);
      } else {
        console.error('[CookieConsentClient] CookieConsent sigue sin estar disponible tras cargar el script');
      }
    };
    document.body.appendChild(script);
    return () => {
      // Limpieza opcional: eliminar el script si el componente se desmonta
      script.remove();
    };
  }, [lang]);
  return null;
}
